// src/pages/Landing.js
import React from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const UnisexPerfumeHeader = () => {
    const { t } = useTranslation();

    return (
        <main className="promotion-header mt-5" style={{ fontFamily: "'Hanuman', Arial, sans-serif" }}>
            <section className="shopping-header unisex-header d-flex justify-content-center align-items-center">
                <Container
                    fluid
                    className="d-flex justify-content-center align-items-center"
                >
                    <div className="d-flex flex-column justify-content-center align-items-center mt-4 mt-md-0">
                        <span className="text-white fs-5 mt-md-0 mt-5">{t("Home / UnisexPerfume")}</span>
                        <h1 className="mt-2 text-white fs-custom">{t("All Men&Women Perfume")}</h1>
                    </div>
                </Container>
            </section>
        </main>
    );
};

export default UnisexPerfumeHeader;
